import * as React from "react";
import { useCallback, useState } from "react";
import styled, { css } from "styled-components";
import useDisclosure from "util/hooks/useDisclosure";
import styles from "./EditableTitle.css";
export const Title = styled.span(
  ({ theme }) => css`
    border: 1px solid ${theme.colors.global.contentBackground};
    font-size: ${theme.fonts.size.large};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  `
);
const StyledInput = styled.input(
  ({ theme }) => css`
    border: 1px solid ${theme.colors.input.border};
    background-color: ${theme.colors.input.background};
    color: ${theme.colors.input.color};
    border-radius: 4px;
    padding: 2px 3px;
    font-size: ${theme.fonts.size.large};

    &:focus {
      border-color: ${theme.colors.input.borderFocus};
      outline: none;
    }
  `
);
const EditableTitle = ({ disabled = false, value: propsValue, onChange }) => {
  const [value, setValue] = useState(propsValue);
  const [editing, { toggle }] = useDisclosure(false);
  const _toggleEditing = useCallback(() => {
    if (!disabled) {
      toggle();
    }
  }, [disabled, toggle]);
  const _onChange = useCallback((evt) => {
    evt.preventDefault();
    setValue(evt.target.value);
  }, []);
  const _submitValue = useCallback(() => {
    if (value !== "") {
      onChange == null ? void 0 : onChange(value);
    } else {
      setValue(propsValue);
    }
  }, [onChange, propsValue, value]);
  const _onBlur = useCallback(() => {
    _toggleEditing();
    _submitValue();
  }, [_submitValue, _toggleEditing]);
  const _onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      _toggleEditing();
      _submitValue();
    },
    [_submitValue, _toggleEditing]
  );
  return editing ? /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("form", { onSubmit: _onSubmit, className: styles.inlineForm }, /* @__PURE__ */ React.createElement(StyledInput, { autoFocus: true, type: "text", value, onBlur: _onBlur, title: "Edit title", onChange: _onChange }))) : /* @__PURE__ */ React.createElement(Title, { onDoubleClick: _toggleEditing, title: `${value} - Double click the title to edit it.` }, value);
};
export default EditableTitle;
